import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";
import { ApplyInputTypeInfo, SubscribeInfoData } from "./agent-user-subinfo-get";


// 原始接口
interface AgentResponse {
  agents: Agents[];
}
export interface Agents {
  id: string;
  name: string;
  avatar: string;
  intro: string;
  creator_id: string;
  status: number;
  enable_status: number;
  created_at: string;
  updated_at: string;
  apply_input_type_info: Apply_input_type_info;
  is_read: number;
};

export interface Apply_input_type_info {
  video_apply_input_type: string;
  article_apply_input_type: string;
  blog_apply_input_type?: string;
  moments_apply_input_type?: string;
  graphic_apply_input_type?: string;
};

// 请求接口
interface AgentListRequest {
  page?: number;
  pageSize?: number;
}

export class ApplyInputTypeInfoData {
  @IsString("videoApplyInputType must be a string")
  videoApplyInputType: string;

  @IsString("blogApplyInputType must be a string")
  blogApplyInputType: string;

  @IsString("momentsApplyInputType must be a string")
  momentsApplyInputType: string;

  @IsString("graphicApplyInputType must be a string")
  graphicApplyInputType: string;

  @IsString("articleApplyInputType must be a string")
  articleApplyInputType: string;
}

export class SubscribeAgentData {
  @Required("Id cannot be empty")
  @IsString("Id cannot be empty")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Avatar cannot be empty")
  @IsString("Avatar must be a string")
  avatar: string;

  @Required("Intro cannot be empty")
  @IsString("Intro must be a string")
  intro: string;

  @IsNumber("isRead must be a number")
  isRead: number;

  @Required("applyInputTypeInfo cannot be empty")
  @ValidateNested(ApplyInputTypeInfoData)
  applyInputTypeInfo: ApplyInputTypeInfoData;

  firstInputType?: number;
}

export class SubscribeAgentListData {
  @IsArray("Agents must be an array")
  agents: SubscribeAgentData[];
}

const transformAndValidateAgent = (
  response: AgentResponse
): SubscribeAgentListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, SubscribeAgentListData);
  } catch (error) {
    console.error("subscribe Agent data validation failed:", error.message);
    throw error;
  }
};

/** 已订阅的 Agent 列表 */
export const subscribeAgentList = async ({ page, pageSize }: AgentListRequest): Promise<SubscribeAgentListData> => {
  const response = await api.post<AgentResponse>('/agent/app-list', {
    page,
    page_size: pageSize,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
